<template>
  <a-layout class='index animated fadeIn s_bf'>
    <a-card :bordered="false">
      <growth />
    </a-card>
  </a-layout>
  <a-modal  :keyboard="false" title="操作记录（只记录近30天操作记录）" centered v-model:visible="showLog" :width='1300' :footer="null" destroyOnClose>
    <vipLog></vipLog>
  </a-modal>
</template>
<script>
  import growth from './components/growth'
  export default {
    components: {  growth },
  }
</script>